<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Laporan Penjualan</h2>

      <br />

      <div class="filter">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">
            Filter
          </button>
        </div>
        <div></div>
        <div class="form-group">
          <label>Export Data</label>
          <button
            type="button"
            class="btn-outline green"
            @click="exportExcel()"
          >
            {{ loadingExcel ? "Loading..." : "Export Excel" }}
          </button>
        </div>
      </div>

      <div class="summary">
        <div class="card">
          <div class="card-body">
            <h2>Rp {{ summary.total_penjualan | number }}</h2>
            <p>Grand Total Penjualan</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h2>{{ summary.jumlah_nota }}</h2>
            <p>Jumlah Nota</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h2>{{ summary.item_terjual }}</h2>
            <p>Item Terjual</p>
          </div>
        </div>
        <div></div>
        <div class="card">
          <div class="card-body">
            <h2>Rp {{ summary.total_penjualan_kotor | number }}</h2>
            <p>Subtotal Penjualan</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h2>Rp {{ summary.total_diskon | number }}</h2>
            <p>Total Diskon</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h2>Rp {{ summary.total_pajak | number }}</h2>
            <p>Total Pajak</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h2>
              Rp
              {{
                (summary.total_pembulatan_atas + summary.total_pembulatan_bawah)
                  | number
              }}
            </h2>
            <p>Total Pembulatan</p>
          </div>
        </div>
      </div>

      <div class="tampilan-detail"><label class="toggle">
          <input type="checkbox" v-model="tampilanDetail" />
          <span
            class="labels"
            data-on="Detail"
            data-off="Summary"
          ></span>
        </label>
      </div>

      <table class="table" v-show="tampilanDetail">
        <thead>
          <tr>
            <th style="width: 50px">No</th>
            <th>Menu</th>
            <th style="width: 150px">Jumlah</th>
            <th style="width: 150px; text-align: right">Harga</th>
            <th style="width: 150px; text-align: right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in data"
            :key="index"
            :class="{
              void: item.status == 'CANCEL_ORDER',
              pending: item.status == 'PENDING',
            }"
            class="subheader"
          >
            <td colspan="5" style="padding: 0">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  background: #eee;
                  padding: 10px;
                "
              >
                <label for=""
                  >{{ item.no_nota }}
                  <b style="text-transform: uppercase">{{
                    item.ojek_online
                  }}</b></label
                >
                <label for="">{{
                  moment(item.tanggal).format("DD-MM-YYYY HH:mm")
                }}</label>
              </div>

              <table width="100%">
                <tr v-for="(menu, k) in item.detail" :key="k">
                  <td style="width: 50px">{{ ++k }}</td>
                  <td>
                    {{ menu.nama }}
                  </td>
                  <td style="width: 150px">
                    {{ menu.jumlah }}
                  </td>
                  <td style="width: 150px" align="right">
                    {{ menu.harga | number }}
                  </td>
                  <td style="width: 150px" align="right">
                    {{
                      (parseInt(menu.jumlah) * parseInt(menu.harga)) | number
                    }}
                  </td>
                </tr>
                <tr class="sum">
                  <td colspan="4" style="border-top: 1px solid #ccc">
                    Subtotal
                  </td>
                  <td align="right" style="border-top: 1px solid #ccc">
                    {{ item.sub_total | number }}
                  </td>
                </tr>
                <tr class="sum">
                  <td colspan="4">Diskon</td>
                  <td align="right">{{ item.jumlah_diskon | number }}</td>
                </tr>
                <tr class="sum">
                  <td colspan="4">Pajak</td>
                  <td align="right">{{ item.pajak | number }}</td>
                </tr>
                <tr class="sum">
                  <td colspan="4">Pembulatan</td>
                  <td align="right">
                    {{
                      (parseInt(item.pembulatan_atas) +
                        parseInt(item.pembulatan_bawah))
                        | number
                    }}
                  </td>
                </tr>
                <tr class="sum">
                  <td colspan="4">
                    Grand Total
                    <span class="ojol">{{ item.tipe_pembayaran }}</span>
                  </td>
                  <td align="right">
                    {{ item.grand_total | number }}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table" v-show="!tampilanDetail">
        <thead>
          <tr>
            <th>No</th>
            <th>Nota</th>
            <th>Meja / Customer</th>
            <th>Waktu Transaksi</th>
            <th>Subtotal</th>
            <th>Jumlah Diskon</th>
            <th>Pajak</th>
            <th>Pembulatan</th>
            <th>Grand Total</th>
            <th>Tipe Bayar</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in data"
            :key="index"
            :class="{
              void: item.status == 'CANCEL_ORDER',
              pending: item.status == 'PENDING',
            }"
            @click="$router.push('/laporan/penjualan/detail/' + item.guid)"
          >
            <td>{{ ++index }}</td>
            <td>
              {{ item.no_nota }}
              <span class="ojol" v-show="item.ojek_online"
                >{{ item.ojek_online }}, {{ item.pin }}</span
              >
            </td>
            <td>{{ item.info || "-" }}</td>
            <td>
              {{ moment(item.tanggal).format("DD MMM YYYY HH:mm") }}
            </td>
            <td>Rp {{ item.sub_total | number }}</td>
            <td>Rp {{ item.jumlah_diskon | number }}</td>
            <td>Rp {{ item.pajak | number }}</td>
            <td>
              Rp
              {{
                item.pembulatan_atas > 0
                  ? item.pembulatan_atas
                  : item.pembulatan_bawah | number
              }}
            </td>
            <td>Rp {{ item.grand_total_manual | number }}</td>
            <td>{{ item.tipe_pembayaran }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "./../../api/Api";
import moment from "moment";

export default {
  name: "Home",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      data: [],
      summary: {},
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-D"),
        metode_bayar: "SEMUA",
      },
      tampilanDetail: true,
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.id_toko = this.$toko.id;
      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v4/laporan/penjualan?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;

          this.data = r.data;
          this.summary = r.summary;

          let x = 0;
          this.data.forEach((item) => {
            const grand_total =
              parseInt(item.sub_total) -
              parseInt(item.jumlah_diskon) +
              parseInt(item.pajak) +
              parseInt(item.pembulatan_atas) +
              parseInt(item.pembulatan_bawah);

            item.grand_total_manual = grand_total;
            x += parseInt(grand_total);

            if (item.no_meja && item.tamu) {
              item.info = `${item.no_meja} / ${item.tamu}`;
            } else if (item.no_meja && item.no_meja != null) {
              item.info = `${item.no_meja}`;
            } else if (item.tamu) {
              item.info = `${item.tamu}`;
            }

            let details = [];
            item.detail.forEach((menu) => {
              if (menu.jumlah > 0) {
                details.push(menu);
              }
            });
            item.detail = details;
          });
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    calculateDiskon(item) {
      let jumlahDiskon = 0;
      if (item.jumlah_diskon) {
        if (item.tipe_diskon == "RUPIAH") {
          jumlahDiskon = item.jumlah_diskon;
        } else {
          jumlahDiskon = (item.jumlah_diskon * item.subtotal) / 100;
        }
      }

      return jumlahDiskon;
    },
    exportExcel() {
      this.loadingExcel = true;
      const payload = [];

      this.data.forEach((item) => {
        item.detail.forEach((detail) => {
          payload.push({
            guid: item.guid,
            tanggal: moment(item.tanggal).format("DD/MM/YYYY HH:mm"),
            no_nota: item.no_nota,
            ojek_online: item.ojek_online,
            pin: item.pin,
            menu: detail.nama,
            harga: detail.harga,
            jumlah: detail.jumlah,
            total: parseInt(detail.jumlah) * parseInt(detail.harga),

            pajak: 0,
            diskon: 0,
            pembulatan: 0,
            sub_total: 0,
            grand_total: 0,
            pembayaran: 0,
          });
        });

        const index = payload.findIndex((k) => k.guid == item.guid);
        payload[index].pajak = item.pajak;
        payload[index].diskon = item.jumlah_diskon;
        payload[index].pembulatan =
          item.pembulatan_atas > 0
            ? item.pembulatan_atas
            : item.pembulatan_bawah;
        payload[index].sub_total = item.sub_total;
        payload[index].grand_total = item.grand_total;
        payload[index].pembayaran = item.tipe_pembayaran;
      });

      const tgl_awal = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const tgl_akhir = moment(this.dateRange.endDate).format("YYYY-MM-DD");

      api
        .postJson(
          "https://app.restoku.id/exporter/penjualan?id_toko=" +
            this.$toko.id +
            "&title=Laporan Penjualan (Semua)" +
            "&tgl_awal=" +
            tgl_awal +
            "&tgl_akhir=" +
            tgl_akhir,
          payload
        )
        .then((r) => {
          if (r.valid) {
            location.href = r.url;
          }

          this.loadingExcel = false;
        })
        .catch((e) => {
          this.$toast("Terjadi kesalahan");
          this.loadingExcel = false;
        });

      console.log(payload);
    },
  },
  mounted() {
    if (this.$route.query.tgl_awal && this.$route.query.tgl_akhir) {
      this.dateRange = {
        startDate: moment(this.$route.query.tgl_awal).format("YYYY-MM-DD"),
        endDate: moment(this.$route.query.tgl_akhir).format("YYYY-MM-DD"),
      };
    }

    this.$store.commit("settings/setMenuActive", "/laporan/penjualan");
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: 240px 150px 1fr 150px;
    grid-column-gap: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }

  .summary {
    display: grid;
    margin-bottom: 20px;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 15px;
    grid-row-gap: 15px;

    .card-body {
      padding: 15px;
      p,
      h2 {
        margin: 0;
      }

      h2 {
        margin-bottom: 10px;
        font-size: 20px;
      }
      p {
        font-size: 14px;
      }
    }
  }

  .ojol {
    font-size: 12px;
    padding: 4px 10px;
    background-color: rgb(214, 255, 202);
    color: rgb(31, 141, 21);
    border-radius: 5px;
    margin-left: 4px;
    margin-top: -2px;
  }

  .badge-tipe-order {
    font-size: 11px;
    background-color: var(--primary);
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .table {
    .void {
      color: #f00;
    }
    .pending {
      color: #777;
    }
    tr {
      &:hover {
        td {
          background-color: #fff;
        }
      }
      td {
        table {
          tr {
            td {
              border-bottom: 0 !important;
            }
            &.sum {
              td {
                font-weight: 700;
                padding: 6px 10px !important;
              }
              &:first-child {
                td {
                  border-top: 1px solid #ccc;
                }
              }
            }
          }
        }
      }
    }
  }

  .tampilan-detail {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
    p {
      margin: 0;
      font-size: 14px;
      margin-right: 10px;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--primary);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px var(--primary);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/laporan/Penjualan.vue